import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { useLocation, useNavigate } from 'react-router-dom';

type ButtonLinkCellRendererParams<DataT = unknown> =
    CellRendererParams<DataT> & {
        getUrl?: (
            data: DataT | undefined,
            location?: LocationT,
        ) =>
            | string
            | { pathname: string; state: { parentLocation: LocationT } };
        getDisabled?: (data: DataT | undefined) => boolean;
        onClick?: (arg1: DataT | undefined) => void;
    };

export default function ButtonLinkCellRenderer<DataT>({
    data,
    getUrl,
    getDisabled,
    onClick: onClickProp,
}: ButtonLinkCellRendererParams<DataT>): React.ReactElement {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const url = getUrl?.(data, location);
    const pathname = typeof url === 'string' ? url : url?.pathname ?? '';
    const state = typeof url === 'string' ? null : url?.state ?? null;

    return (
        <Button
            variant="contained"
            sx={{ height: '26px', minHeight: '26px' }}
            onClick={() => {
                if (onClickProp) onClickProp(data);
                navigate(pathname, { state });
            }}
            disabled={getDisabled && getDisabled(data)}
        >
            {t('budgetProposal.view')}
        </Button>
    );
}
